/**
 * Controller: ManageSecondaryContactModal
 */
angular.module('acme.view.application.partners.create.manageSecondaryContactModal.controllers', [
  'acme.common.service.api',
  'acme.common.service.validate'
])
.controller('ManageSecondaryContactModalController', [ '$scope', '$state', '$timeout', '$uibModalInstance', 'ApiService', 'ValidateService', 'contact', 'address', 'organizationId', 'organizationName', 'alertMessage', function($scope, $state, $timeout, $uibModalInstance, ApiService, ValidateService, contact, address, organizationId, organizationName, alertMessage) {

    $scope.manageSecondaryContactModal = {

      title: 'Add Contact',

      errors: [],

      isSubmitted: false,

      model: {},

      createAddress: false,
      address: false,

      viewId: $state.current.name,

      loadPreferences: $state.current.data.enablePreferences,

      init: function() {
        if(contact) {
          this.title = 'Edit contact';
          this.model = contact;
        }

        if (organizationId) {
          this.organizationId = organizationId;
        }

        if (organizationName) {
          this.organizationName = organizationName;
        }

        if (!address) {
          if (contact && contact.id) {
            this.getContactAddress(contact.id);
          }
        }else{
          this.address = address;
        }

        if (alertMessage) {
          this.alertMessage = alertMessage;
        }

        $scope.$on('AddressCreate::Close', this.onAddressCreateClose);
        $scope.$on('AddressCreate::Complete', this.onAddressCreateComplete);
        $scope.$on('AddressList::Create', this.onAddressListCreate);
        $scope.$on('AddressList::Select', this.onAddressListSelect);
        $scope.$on('AddressList::Edit', this.onAddressListEdit);
      },

      getContactAddress: function(contactId) {
        ApiService.organizations.contacts.detail({
          organizationId: this.organizationId,
          contactId: contactId
        }).then(this.success.getAddress, this.error.getAddress);
      },

      isValid: function(field) {
        var r = true;

        if(this.isSubmitted) {
          r = ValidateService.validate([
            {
              len: {
                value: this.model[field]
              }
            }
          ]);
        }
        return r;
      },

      isValidEmail: function(email) {
        var r = true;

        if(this.isSubmitted) {
          r = ValidateService.validate([{email: email}]);
        }
        return r;
      },

      isValidPhone: function(phone) {
        var r = true;
        if(this.isSubmitted) {
          r = ValidateService.validate([{phone: phone}]);
        }
        return r;
      },

      prepareAddress: function() {

        this.model.addressId = this.address.addressId;
        this.model.streetAddress1 = this.address.streetAddress1;
        this.model.streetAddress2 = this.address.streetAddress2;
        this.model.city = this.address.city;
        this.model.state = this.address.state;
        this.model.zipCode = this.address.zipCode;
        this.model.country = this.address.country;
        this.model.isPrimary = this.address.isPrimary;
      },

      done: function() {
        var self = $scope.manageSecondaryContactModal,
            validators = [];

        self.isSubmitted = true;
        $scope.$broadcast('AddressCreate::Check');
        self.prepareAddress();

        validators = [
          { len: { value: self.model.firstName } },
          { len: { value: self.model.lastName } },
          { email: self.model.email },
          { phone: self.model.phoneNumber },
          { len: { value: self.model.country } },
          { len: { value: self.model.streetAddress1 } },
          { len: { value: self.model.city } },
          { len: { value: self.model.zipCode } }
        ];

        if (
          self.model.country && 
          (
            self.model.country === 'Canada' || 
            self.model.country === 'United States'
          )
        ) {
          validators.push({ len: { value: self.model.state } });
        }

        if (ValidateService.validate(validators)) {
          $uibModalInstance.close(this.model, this.address);
        }else {
          self.errors = [ {message: 'Please correct the errors below.'} ];
        }
      },

      cancel: function() {
        $uibModalInstance.dismiss('cancel');
      },

      success: {
        getAddress: function(response) {
          var self = $scope.manageSecondaryContactModal;

          self.createAddress = false;
          self.address = response.data.payload;
          self.prepareAddress();
        }
      },

      error: {
        getAddress: function(response) {}
      },

      onAddressCreateComplete: function(e, data) {
        var self = $scope.manageSecondaryContactModal;

        self.errors = [];

        if (data.select) {
          self.createAddress = false;
          self.address = data.address;
          self.prepareAddress();
        }
        $scope.$broadcast('AddressList::Refresh', { address: self.address });
      },

      onAddressCreateClose: function(e, data) {
        $scope.manageSecondaryContactModal.createAddress = false;
      },

      onAddressListEdit: function(e, data) {
        var self = $scope.manageSecondaryContactModal;

        self.address = data.address;
        self.createAddress = true;
      },

      onAddressListCreate: function(e, data) {
        var self = $scope.manageSecondaryContactModal;

        self.address = {
          country: '',
          type: 'secondary'
        };

        self.createAddress = true;
      },

      onAddressListSelect: function(e, data) {
        var self = $scope.manageSecondaryContactModal;
        if (data.selected) {
          self.address = data.address;
        }
      }

    };


    $scope.manageSecondaryContactModal.init();

}]);